import Card from '../Card/Card';
import './Slider.css'

// function for slider
/**
 * 
 * @param imageDetails- param1 - details of content
 * @param card- param 2 - to decide whether inside is card or just an image
 * @returns 
 */
const Slider = ({ imageDetails, card }) => {

    return (
        <div className="container-fluid mt-3">
            {/* optional section if heading text prop is present */}
            {imageDetails?.headingText && <h2 className="text-center" style={{ fontFamily: "cursive" }}>{imageDetails.headingText}</h2>}
            <div id={imageDetails.carouselId} className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    {imageDetails.details.map((image, index) => (
                        <button
                            key={image.id}
                            data-bs-target={`#${imageDetails.carouselId}`}
                            data-bs-slide-to={index.toString()}
                            className={index === 0 ? 'active' : ''}
                        ></button>
                    ))}
                </div>
                {/* inner-carousel */}
                <div className="carousel-inner">
                    {imageDetails.details.map((details, index) => (
                        <div key={index} className={`carousel-item ${index === 0 ? 'active' : ' '}`}>
                            {card ? <Card details={details} />
                                :
                                <img key={details.id} className="d-block w-100 rounded carousel-image" src={details.src}
                                    alt={details.altText} />}
                        </div>
                    ))}
                </div>
                {/* controls of carousel */}
                <button className="carousel-control-prev" href={`#${imageDetails.carouselId}`}
                    data-bs-slide="prev">
                    <span className="carousel-control-prev-icon"
                        aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" href={`#${imageDetails.carouselId}`}
                    data-bs-slide="next">
                    <span className="carousel-control-next-icon"
                        aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    )
}

export default Slider;